/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, KRISHAK_INFO_SCREEN, COMMON, ADD_KRISHAK_SCREEN, SYNC_SERVICE } from '../../global/Constants';
import './krishak.css';
import moment from 'moment';
import Header from '../common/Header';
import { HeaderTypes } from "../../global/Enum";
import DesktopFooter from '../common/DesktopFooter';
import Utilities from '../../global/Utilities';
import ApiServices from '../../providers/ApiServices';
import Loader from '../common/loader/Loader';
//import SyncServices from '../../providers/SyncServices';
import SyncLoader from '../common/loader/SyncLoader';

class KrishakInfoPage extends Component {

    constructor(props) {
        super(props)
        this.goBack = this.goBack.bind(this);
        this.state = {
            currentTab: 0,
            krishakInfo: {},
            isLoading: false,
            cropsPlanted: [],
            usHybrids: [],
            otherHybrids: [],
            nearestDrs: [],
            influencingFactors: [],
            krishakImages: [],
            appsUsed: [],
            fellowFarmerMobileNumbers: []
        }
    }

    componentDidMount() {
        let id;
        if (this.props.location.state !== undefined) {
            id = this.props.location.state.krishak_id;
        }
        this.getKrishakById(id ? id.toString() : "1");
    }

    getKrishakById = (krishakId) => {

        this.setState({ isLoading: true });
        var body = JSON.stringify({
            krishak_id: krishakId,
        });
        try {
            ApiServices.getKrishakById(body).then(response => {
                var status = response.success;
                if (status) {
                    this.setState({ isLoading: false });
                    const data = response.data;
                    if (data != null) {

                        const krishakInfo = data;
                        krishakInfo.qualification_name = data.qualification_name.label;

                        this.setState({
                            krishakInfo,
                            cropsPlanted: data.krishak_crops_planteds,
                            krishakImages: data.krishak_images,
                            appsUsed: data.phone_app,
                            usHybrids: data.krishak_hybrid_purchaseds,
                            otherHybrids: data.krishak_other_brands,
                            nearestDrs: data.krishak_near_retailers,
                            influencingFactors: data.krishak_influence_factors,
                            fellowFarmerMobileNumbers: data.krishak_fellow_farmer_phones
                        })

                    }
                } else {
                    alert("No Krishak Found");
                    this.goBack();
                }

            }).catch(error => {
                Utilities.LogPrint("getKrishakById", error);
            });
        } catch (error) {
            this.setState({ isLoading: false });
            Utilities.LogPrint("getKrishakById", error);
        }

        // SyncServices.findKrishakFromDatabase("krishak_id", krishak_id).then(data => {
        //     if (data) {
        //         if (data.is_active === undefined || data.is_active === null || data.is_active === 1) {
        //             const krishakInfo = data;
        //             this.setState({
        //                 krishakInfo,
        //                 cropsPlanted: krishakInfo.krishak_crops_planteds,
        //                 krishakImages: krishakInfo.krishak_images,
        //                 appsUsed: krishakInfo.phone_app,
        //                 usHybrids: krishakInfo.krishak_hybrid_purchaseds,
        //                 otherHybrids: krishakInfo.krishak_other_brands,
        //                 nearestDrs: krishakInfo.krishak_near_retailers,
        //                 influencingFactors: krishakInfo.krishak_influence_factors,
        //                 fellowFarmerMobileNumbers: krishakInfo.krishak_fellow_farmer_phones

        //             });
        //         } else {
        //             this.checkKrishakOffline(krishak_id);
        //         }
        //     } else {
        //         this.checkKrishakOffline(krishak_id);
        //     }
        // });
    }

    // checkKrishakOffline = (temp_krishak_id) => {
    //     SyncServices.findKrishakFromDatabase("temp_krishak_id", temp_krishak_id).then(data => {
    //         if (data) {
    //             if (data.is_active === undefined || data.is_active === null || data.is_active === 1) {
    //                 const krishakInfo = data;
    //                 krishakInfo.qualification_name = data.qualification_name.label;

    //                 this.setState({
    //                     krishakInfo,
    //                     cropsPlanted: data.krishak_crops_planteds,
    //                     krishakImages: data.krishak_images,
    //                     appsUsed: data.phone_app,
    //                     usHybrids: data.krishak_hybrid_purchaseds,
    //                     otherHybrids: data.krishak_other_brands,
    //                     nearestDrs: data.krishak_near_retailers,
    //                     influencingFactors: data.krishak_influence_factors,
    //                     fellowFarmerMobileNumbers: data.krishak_fellow_farmer_phones
    //                 })
    //             }
    //         } else {
    //             alert("No Krishak Found");
    //             this.goBack();
    //         }
    //     });
    // }

    goBack() {
        this.props.history.goBack();
    }

    handleEditClick = () => {
        this.props.history.push({
            pathname: ALL_ROUTES.ADD_KRISHAK_ROUTE,
            state: { krishakInfo: this.state.krishakInfo }
        });
    }

    handleDeleteClick = (e) => {
        e.preventDefault();
        const r = window.confirm("Are you sure you want to delete this Krishak ?");

        if (r) {
            this.deleteKrishakApi();
        }
    }

    deleteKrishakApi = () => {

        const { krishakInfo } = this.state;

        // let updatedObject = krishakInfo;
        // updatedObject.is_active = 0;
        // SyncServices.updateKrishakToDatabase(updatedObject, updatedObject.phone, (krishakInfo.is_prerak === 1) ? "true" : "false", updatedObject.krishak_id.toString(), updatedObject.temp_krishak_id);
        // this.goBack()

        this.setState({ isLoading: true });
        var body = JSON.stringify({
            krishak_id: krishakInfo?.krishak_id,
        });
        try {
            ApiServices.deleteKrishak(body).then(response => {
                var status = response.success;
                if (status) {
                    alert(response.message)
                    this.goBack()
                }
                this.setState({ isLoading: false });
            }).catch(error => {
                this.setState({ isLoading: false });
            });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    handleTabClick = (e, tab) => {
        e.preventDefault();
        this.setState({
            currentTab: tab
        })
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isSyncLoading, tableName } = this.state;
        const { currentTab, isLoading, fellowFarmerMobileNumbers, appsUsed, krishakInfo, krishakImages, nearestDrs, influencingFactors, cropsPlanted, usHybrids, otherHybrids } = this.state;
        const cropsPlantedListItem = cropsPlanted.map((crop, i) =>
            <div key={i} className="row m-0 w-100">
                <div className="col-lg-2 col-2 mb-3 ml-0">
                    <div >{crop.crop_name} </div>
                </div>
                <div className=" col-lg-10 col-10 mb-3 font-weight-medium">
                    {crop.planted_area + " " + "Acres"} { }</div>
            </div>
        );

        const mobileCropsPlantedListItem = cropsPlanted.map((crop, i) =>
            <div key={i} className="row mb-2">
                <div className="col-4">
                    {crop.crop_name}
                </div>
                <div className="col-8">
                    <span className="d-block font-weight-medium">{crop.planted_area + " " + "Acres"}</span>
                </div>
            </div>
        );

        const usHybridsListItem = usHybrids.map((hybrid, i) =>
            <div key={i}>  {hybrid.hybrid_name} - {hybrid.quantity} {hybrid.weight_unit_name}</div>
        );

        const usHybridsMobileListItem = usHybrids.map((hybrid, i) =>
            <span key={i} className="d-block font-weight-medium">{hybrid.hybrid_name} - {hybrid.quantity} {hybrid.weight_unit_name}</span>
        );

        const nearestDrsListItem = nearestDrs.map((dr, i) =>
            <div key={i}> {dr.retailer_name} </div>
        );

        const nearestDrsMobileListItem = nearestDrs.map((dr, i) =>
            <span key={i} className="d-block font-weight-medium">{dr.retailer_name}</span>
        );

        const influencingFactorsListItem = influencingFactors.map((factor, i) =>
            <div key={i}> {factor.influence_factor_name} </div>
        );

        const influencingFactorsMobileListItem = influencingFactors.map((factor, i) =>
            <span key={i} className="d-block font-weight-medium">{factor.influence_factor_name}</span>
        );

        const otherHybridsListItem = otherHybrids.map((hybrid, i) =>
            hybrid.competitor_hybrid ? <div key={i}>  {hybrid.competitor_hybrid.season_name} - {hybrid.quantity} {hybrid.Weight_unit_name} </div> : null
        );

        const otherHybridsMobileListItem = otherHybrids.map((hybrid, i) =>
            hybrid.competitor_hybrid ? <span key={i} className="d-block font-weight-medium">{hybrid.competitor_hybrid.season_name} - {hybrid.quantity} {hybrid.Weight_unit_name}</span> : null
        );

        const krishakImagesListItem = krishakImages?.map((imageData, i) =>
            <div key={i} className="image-info">
                <img src={imageData.image_url} alt="" />
            </div>
        );

        const krishakMobileImagesListItem = krishakImages?.map((imageData, i) =>
            <div className="col-4 image-info">
                <img key={i} src={imageData.image_url} alt="" />
            </div>
        );

        const fellowFarmerMobileNumbersListItem = fellowFarmerMobileNumbers?.map((number, i) =>
            <span key={i} className="d-block font-weight-medium">{number.phone}</span>
        );

        const appsUsedMobileListItem = appsUsed.map((app, i) =>
            <div key={i}>
                {app.name}
            </div>
        );

        const appsUsedListItem = appsUsed.map((app, i) =>
            <div key={i}>{app.name}</div>
        );

        return (
            <div>
                <Header selectedTab={HeaderTypes.KRISHAK} handleSyncLoading={this.handleSyncLoading} />
                <div className="container pt-35 pb-3">
                    <div className="row">
                        <div className="col-12">
                            <div className="float-left">
                                <h3 className="title">{KRISHAK_INFO_SCREEN.KRISHAK_INFORMATION}</h3>
                            </div>
                            <button className="btn btn-secondary float-right mt-2 w-182 d-none d-lg-block" onClick={() => this.goBack()}>{COMMON.BACK}</button>
                            <button className="btn btn-secondary float-right mt-2 w-182 d-none d-lg-block add-btn mr-3" data-toggle="modal" data-target="#farmerMobileModal" >{COMMON.ADD}</button>
                        </div>
                    </div>

                    <div className="row d-md-none">
                        <div className="col-12 krishak-info">
                            {/* General Info */}
                            <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#collapseGeneral" aria-expanded="false" aria-controls="collapseGeneral">
                                {ADD_KRISHAK_SCREEN.GENERAL}
                                <i className="customic ic-down-arrow ml-auto"></i>
                            </a>

                            <div className="row">
                                <hr className="w-100" />
                            </div>
                            <div className="col-12 px-sm-3 px-0 pending-act-body collapse show" id="collapseGeneral">
                                <div className="row mb-2">
                                    <div className="col-12 font-weight-medium">
                                        {ADD_KRISHAK_SCREEN.PERSONAL_DETAILS}
                                    </div>
                                    <div className="col-5">
                                        <span className="d-block">{COMMON.NAME}</span>
                                    </div>
                                    <div className="col-7">
                                        <span className="d-block font-weight-medium">{krishakInfo.name}</span>
                                    </div>
                                    <div className="col-5">
                                        <span className="d-block">{COMMON.MOBILE_NUMBER}</span>
                                    </div>
                                    <div className="col-7">
                                        <span className="d-block font-weight-medium">+91 - {krishakInfo.phone}</span>
                                    </div>
                                    <div className="col-5">
                                        <span className="d-block">{COMMON.DOB}</span>
                                    </div>
                                    <div className="col-7">
                                        <span className="d-block font-weight-medium">{moment(krishakInfo.dob, "YYYY-MM-DD").format("DD-MM-YYYY")}</span>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-12 font-weight-medium">
                                        {ADD_KRISHAK_SCREEN.LOCATION_DETAILS}
                                    </div>
                                    <div className="col-5">
                                        {COMMON.STREET_ADDRESS}
                                    </div>
                                    <div className="col-7">
                                        <span className="d-block font-weight-medium"></span>
                                    </div>
                                    <div className="col-5">
                                        {COMMON.STATE}
                                    </div>
                                    <div className="col-7">
                                        <span className="d-block font-weight-medium">{krishakInfo.state_name}</span>
                                    </div>
                                    <div className="col-5">
                                        {COMMON.CITY}
                                    </div>
                                    <div className="col-7">
                                        <span className="d-block font-weight-medium">{krishakInfo.district_name}</span>
                                    </div>
                                    <div className="col-5">
                                        {COMMON.TEHSIL}
                                    </div>
                                    <div className="col-7">
                                        <span className="d-block font-weight-medium">{krishakInfo.tehsil_name}</span>
                                    </div>
                                    <div className="col-5">
                                        {COMMON.VILLAGE}
                                    </div>
                                    <div className="col-7">
                                        <span className="d-block font-weight-medium">{krishakInfo.village_name}</span>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-12 font-weight-medium">
                                        {ADD_KRISHAK_SCREEN.ADDITIONAL_DETAILS}
                                    </div>
                                    <div className="col-5">
                                        {ADD_KRISHAK_SCREEN.EDUCATIONAL_QUALIFICATION}
                                    </div>
                                    <div className="col-7 font-weight-medium">
                                        {krishakInfo.qualification_name}
                                    </div>
                                    <div className="col-5">
                                        {ADD_KRISHAK_SCREEN.SMART_PHONE_USER}
                                    </div>
                                    <div className="col-7 font-weight-medium">
                                        {krishakInfo.is_smart_phone === 0 ? COMMON.NO : COMMON.YES}
                                    </div>
                                    <div className="col-5">
                                        {ADD_KRISHAK_SCREEN.SELECT_APP_USED}
                                    </div>
                                    <div className="col-7 font-weight-medium">
                                        {appsUsedMobileListItem}

                                    </div>
                                    <div className="col-5">
                                        {ADD_KRISHAK_SCREEN.CAN_BE_PRERAK}
                                    </div>
                                    <div className="col-7 font-weight-medium">
                                        {krishakInfo.is_prerak === 0 ? COMMON.NO : COMMON.YES}
                                    </div>
                                    <div className="col-5">
                                        {ADD_KRISHAK_SCREEN.KNOW_YOUR_PRERAK}
                                    </div>
                                    <div className="col-7 font-weight-medium">
                                        {krishakInfo.is_know_prerak === 0 ? COMMON.NO : COMMON.YES}
                                    </div>

                                </div>
                                <div className="row mb-3">
                                    <div className="col-12 font-weight-medium">
                                        {ADD_KRISHAK_SCREEN.IRRIGATION_SOURCE}
                                    </div>
                                    <div className="col-5">
                                        {ADD_KRISHAK_SCREEN.TYPE_OF_SOURCE}
                                    </div>
                                    <div className="col-7">
                                        <span className="d-block font-weight-medium">{krishakInfo.irrigation_source_name}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <hr className="w-100" />
                                </div>
                            </div>


                            {/* Cropping Info */}
                            <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#collapseCropping" aria-expanded="false" aria-controls="collapseCropping">
                                {ADD_KRISHAK_SCREEN.CROPPING}
                                <i className="customic ic-down-arrow ml-auto"></i>
                            </a>

                            <div className="row">
                                <hr className="w-100" />
                            </div>

                            <div className="col-12 px-sm-3 px-0 pending-act-body collapse show" id="collapseCropping">
                                <div className="row mb-2">
                                    <div className="col-4">
                                        {ADD_KRISHAK_SCREEN.TOTAL_OWNED}
                                    </div>
                                    <div className="col-8">
                                        <span className="d-block font-weight-medium">{krishakInfo.total_owned} {krishakInfo.total_owned_area_unit_name}</span>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-4">
                                        {ADD_KRISHAK_SCREEN.TOTAL_LEASED}
                                    </div>
                                    <div className="col-8">
                                        <span className="d-block font-weight-medium">{krishakInfo.total_leased} {krishakInfo.total_leased_area_unit_name}</span>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-4">
                                        {ADD_KRISHAK_SCREEN.IRRIGATED}
                                    </div>
                                    <div className="col-8">
                                        <span className="d-block font-weight-medium">{krishakInfo.irrigated} {krishakInfo.irrigated_area_unit_name}</span>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-4">
                                        {ADD_KRISHAK_SCREEN.RAINFED}
                                    </div>
                                    <div className="col-8">
                                        <span className="d-block font-weight-medium">{krishakInfo.rainfed} {krishakInfo.rainfed_area_unit_name}</span>
                                    </div>
                                </div>
                                {mobileCropsPlantedListItem}
                                <div className="row">
                                    <hr className="w-100" />
                                </div>
                            </div>

                            {/* Brand Loyalty Info */}
                            <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#collapseBrandLoyalty" aria-expanded="false" aria-controls="collapseBrandLoyalty">
                                {ADD_KRISHAK_SCREEN.BRAND_LOYALTY}
                                <i className="customic ic-down-arrow ml-auto"></i>
                            </a>

                            <div className="row">
                                <hr className="w-100" />
                            </div>

                            <div className="col-12 px-sm-3 px-0 pending-act-body collapse show" id="collapseBrandLoyalty">
                                <div className="row mb-2">
                                    <div className="col-4">
                                        {ADD_KRISHAK_SCREEN.BRAND_PURCHASED}
                                    </div>
                                    <div className="col-8">
                                        <span className="d-block font-weight-medium">{ADD_KRISHAK_SCREEN.US_BRANDS}</span>
                                        <span className="d-block font-weight-medium">{ADD_KRISHAK_SCREEN.OTHER_BRANDS}</span>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-4">
                                        {ADD_KRISHAK_SCREEN.US_HYBRIDS}
                                    </div>
                                    <div className="col-8">
                                        {usHybridsMobileListItem}
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4">
                                        {ADD_KRISHAK_SCREEN.OTHER_BRANDS_HYBRIDS}
                                    </div>
                                    <div className="col-8">
                                        {otherHybridsMobileListItem}
                                    </div>
                                </div>
                                <div className="row">
                                    <hr className="w-100" />
                                </div>
                            </div>

                            {/* Prerak Info */}
                            <a href="" className={(krishakInfo.is_prerak === 1) ? "font-weight-medium d-flex w-100 align-items-center my-3" : "d-none"} data-toggle="collapse" data-target="#collapsePrerak" aria-expanded="false" aria-controls="collapsePrerak">
                                {COMMON.PRERAK}
                                <i className="customic ic-down-arrow ml-auto"></i>
                            </a>

                            <div className="row">
                                <hr className="w-100" />
                            </div>

                            <div className={(krishakInfo.is_prerak === 1) ? "col-12 px-sm-3 px-0 pending-act-body collapse show" : "d-none"} id="collapsePrerak">
                                <div className="row mb-2">
                                    <div className="col-4">
                                        {ADD_KRISHAK_SCREEN.SOURCE_INFORMATION_SEEDS}
                                    </div>
                                    <div className="col-8">
                                        <span className="d-block font-weight-medium">{ADD_KRISHAK_SCREEN.FELLOW_FARMER}</span>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-4">
                                        {ADD_KRISHAK_SCREEN.NEAREST_AGRI_DISTRIBUTOR_RETAILER}
                                    </div>
                                    <div className="col-8">
                                        {nearestDrsMobileListItem}
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-4">
                                        {ADD_KRISHAK_SCREEN.FACTORS_INFLUENCING_PURCHASE_INTENTION}
                                    </div>
                                    <div className="col-8">
                                        {influencingFactorsMobileListItem}
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-4">
                                        {ADD_KRISHAK_SCREEN.POINTS_OF_DECISION_MAKING}
                                    </div>
                                    <div className="col-8">
                                        <span className="d-block font-weight-medium">{krishakInfo.krishak_decision_making_name}</span>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-4">
                                        {ADD_KRISHAK_SCREEN.FAVOURITE_TV_SHOW}
                                    </div>
                                    <div className="col-8">
                                        <span className="d-block font-weight-medium">{krishakInfo.favourite_tv}</span>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-4">
                                        {ADD_KRISHAK_SCREEN.FAVOURITE_RADIO_SHOW}
                                    </div>
                                    <div className="col-8">
                                        <span className="d-block font-weight-medium">{krishakInfo.favourite_radio}</span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4">
                                        {ADD_KRISHAK_SCREEN.FAVOURITE_NEWSPAPER}
                                    </div>
                                    <div className="col-8">
                                        <span className="d-block font-weight-medium">{krishakInfo.favourite_news}</span>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-4">
                                        {ADD_KRISHAK_SCREEN.FELLOW_FARMER_MOBILE_NUMBERS}
                                    </div>
                                    <div className="col-8">
                                        {fellowFarmerMobileNumbersListItem}
                                    </div>
                                </div>

                                <div className="row">
                                    <hr className="w-100" />
                                </div>
                            </div>

                            {/* Fellow Farmers Mobile Numbers Info */}
                            {/* <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#collapseFarmersMobileNumbers" aria-expanded="false" aria-controls="collapseFarmersMobileNumbers">
                                {ADD_KRISHAK_SCREEN.FELLOW_FARMER_MOBILE_NUMBERS}
                                <i className="customic ic-down-arrow ml-auto"></i>
                            </a>

                            <div className="row">
                                <hr className="w-100" />
                            </div>

                            <div className="col-12 px-sm-3 px-0 pending-act-body collapse show mb-3" id="collapseFarmersMobileNumbers">
                                <div className="row mb-3">
                                    <div className="col-4">
                                        {KRISHAK_INFO_SCREEN.MOBILE_NUMBERS}
                                    </div>
                                    <div className="col-8">
                                        <span className="d-block font-weight-medium">{farmerMobileNumber}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <hr className="w-100" />
                                </div>
                            </div> */}

                            {/* Remarks Info */}
                            <span className="d-flex w-100 align-items-center mt-3">
                                {ADD_KRISHAK_SCREEN.REMARKS}
                            </span>
                            <span className="d-flex font-weight-medium mb-3">{krishakInfo.remark}</span>

                            <div className="row">
                                <hr className="w-100" />
                            </div>

                            {/* Images Info */}
                            <span className="font-weight-medium d-flex w-100 align-items-center mt-3 mb-2">{ADD_KRISHAK_SCREEN.IMAGES}</span>
                            <div className="row row7-5 mb-3">
                                {krishakMobileImagesListItem}
                            </div>
                        </div>
                    </div>

                    {/* New desktop screen */}
                    <div className="row d-none d-md-flex pb-65">
                        <div className="col-12 krishak-tab-header krishak-info-tabs mt-4">
                            <ul>
                                <li className={currentTab === 0 ? "krishak-tab active-tab" : "krishak-tab validated"} onClick={(e) => this.handleTabClick(e, 0)} data-krishak-tab="general-body">
                                    <div className="tab-color"></div>
                                    <i className="krishak-img general"></i>
                                    <span className="d-inline-block w-100 font-weight-medium">{ADD_KRISHAK_SCREEN.GENERAL}</span>
                                </li>
                                <li className={currentTab === 1 ? "krishak-tab active-tab" : "krishak-tab validated"} onClick={(e) => this.handleTabClick(e, 1)} data-krishak-tab="cropping-body">
                                    <div className="tab-color"></div>
                                    <i className="krishak-img cropping"></i>
                                    <span className="d-inline-block w-100 font-weight-medium">{ADD_KRISHAK_SCREEN.CROPPING}</span>
                                </li>
                                <li className={currentTab === 2 ? "krishak-tab active-tab" : "krishak-tab validated"} onClick={(e) => this.handleTabClick(e, 2)} data-krishak-tab="brand-loyalty-body">
                                    <div className="tab-color"></div>
                                    <i className="krishak-img brand-loyalty"></i>
                                    <span className="d-inline-block w-100 font-weight-medium">{ADD_KRISHAK_SCREEN.BRAND_LOYALTY}</span>
                                </li>
                                <li className={(krishakInfo.is_prerak === 1) ? (currentTab === 3 ? "krishak-tab active-tab" : "krishak-tab validated") : "d-none"} onClick={(e) => this.handleTabClick(e, 3)} data-krishak-tab="prerak-body">
                                    <div className="tab-color"></div>
                                    <i className="krishak-img prerak"></i>
                                    <span className="d-inline-block w-100 font-weight-medium">{COMMON.PRERAK}</span>
                                </li>
                                <li className={currentTab === 4 ? "krishak-tab active-tab" : "krishak-tab validated"} onClick={(e) => this.handleTabClick(e, 4)} data-krishak-tab="last-step-body">
                                    <div className="tab-color"></div>
                                    <i className="krishak-img last-step"></i>
                                    <span className="d-inline-block w-100 font-weight-medium">{ADD_KRISHAK_SCREEN.REMARKS}</span>
                                </li>
                            </ul>
                        </div>
                        <div className="col-12 mt-4">
                            <div className={currentTab === 0 ? "row krishak-tab-info general-body" : "row krishak-tab-info general-body d-none"}>
                                <div className="col-lg-2 col-4 font-weight-medium">
                                    {ADD_KRISHAK_SCREEN.PERSONAL_DETAILS}
                                </div>
                                <div className="col-lg-10 col-8"></div>
                                <div className="col-lg-2 col-4">{COMMON.NAME}</div>
                                <div className="col-lg-10 col-8 font-weight-medium">{krishakInfo.name}</div>
                                <div className="col-lg-2 col-4">{COMMON.MOBILE_NUMBER}</div>
                                <div className="col-lg-10 col-8 font-weight-medium">{krishakInfo.phone}</div>
                                <div className="col-lg-2 col-4">{COMMON.DOB}</div>
                                <div className="col-lg-10 col-8 font-weight-medium">{moment(krishakInfo.dob, "YYYY-MM-DD").format("DD-MM-YYYY")}</div>


                                <div className="col-lg-2 col-4 mt-3 font-weight-medium">
                                    {ADD_KRISHAK_SCREEN.LOCATION_DETAILS}
                                </div>
                                <div className="col-lg-10 col-8"></div>
                                <div className="col-lg-2 col-4">{COMMON.STREET_ADDRESS}</div>
                                <div className="col-lg-10 col-8 font-weight-medium"></div>
                                <div className="col-lg-2 col-4">{COMMON.STATE}</div>
                                <div className="col-lg-10 col-8 font-weight-medium">{krishakInfo.state_name}</div>
                                <div className="col-lg-2 col-4">{COMMON.CITY}</div>
                                <div className="col-lg-10 col-8 font-weight-medium">{krishakInfo.district_name}</div>
                                <div className="col-lg-2 col-4">{COMMON.TEHSIL}</div>
                                <div className="col-lg-10 col-8 font-weight-medium">{krishakInfo.tehsil_name}</div>
                                <div className="col-lg-2 col-4">{COMMON.VILLAGE}</div>
                                <div className="col-lg-10 col-8 font-weight-medium">{krishakInfo.village_name}</div>


                                <div className="col-lg-2 col-4 mt-3 font-weight-medium">
                                    {ADD_KRISHAK_SCREEN.ADDITIONAL_DETAILS}
                                </div>
                                <div className="col-lg-10 col-8"></div>
                                <div className="col-lg-2 col-4">{ADD_KRISHAK_SCREEN.EDUCATIONAL_QUALIFICATION}</div>
                                <div className="col-lg-10 col-8 font-weight-medium">{krishakInfo.qualification_name}</div>
                                <div className="col-lg-2 col-4">{ADD_KRISHAK_SCREEN.SMART_PHONE_USER}</div>
                                <div className="col-lg-10 col-8 font-weight-medium">{krishakInfo.is_smart_phone === 0 ? COMMON.NO : COMMON.YES}</div>
                                <div className="col-lg-2 col-4">{ADD_KRISHAK_SCREEN.SELECT_APP_USED}</div>
                                <div className="col-lg-10 col-8 font-weight-medium">{appsUsedListItem}</div>

                                {/* <div className="col-lg-2 col-4">Can be a Prerak</div>
                                <div className="col-lg-10 col-8 font-weight-medium">{krishakInfo.is_smart_phone===0?"No":"Yes"}</div> */}
                                <div className="col-lg-2 col-4">{ADD_KRISHAK_SCREEN.KNOW_YOUR_PRERAK}</div>
                                <div className="col-lg-10 col-8 font-weight-medium">{krishakInfo.is_know_prerak === 0 ? COMMON.NO : COMMON.YES}</div>

                                <div className="col-lg-2 col-4 mt-3 font-weight-medium">
                                    {ADD_KRISHAK_SCREEN.IRRIGATION_SOURCE}
                                </div>
                                <div className="col-lg-10 col-8"></div>
                                <div className="col-lg-2 col-4">{ADD_KRISHAK_SCREEN.TYPE_OF_SOURCE}</div>
                                <div className="col-lg-10 col-8 font-weight-medium">{krishakInfo.irrigation_source_name}</div>

                            </div>

                            <div className={currentTab === 1 ? "row krishak-tab-info cropping-body" : "row krishak-tab-info cropping-body d-none"}>
                                <div className="col-lg-2 col-2 mb-3">
                                    {ADD_KRISHAK_SCREEN.TOTAL_OWNED}
                                </div>
                                <div className="col-lg-10 col-10 mb-3 font-weight-medium">
                                    {krishakInfo.total_owned} {krishakInfo.total_owned_area_unit_name}
                                </div>
                                <div className="col-lg-2 col-2 mb-3">
                                    {ADD_KRISHAK_SCREEN.TOTAL_LEASED}
                                </div>
                                <div className="col-lg-10 col-10 mb-3 font-weight-medium">
                                    {krishakInfo.total_leased} {krishakInfo.total_leased_area_unit_name}
                                </div>
                                <div className="col-lg-2 col-2 mb-3">
                                    {ADD_KRISHAK_SCREEN.IRRIGATED}
                                </div>
                                <div className="col-lg-10 col-10 mb-3 font-weight-medium">
                                    {krishakInfo.irrigated} {krishakInfo.irrigated_area_unit_name}
                                </div>
                                <div className="col-lg-2 col-2 mb-3">
                                    Rainfed
                                </div>
                                <div className="col-lg-10 col-10 mb-3 font-weight-medium">
                                    {krishakInfo.rainfed} {krishakInfo.rainfed_area_unit_name}
                                </div>
                                {cropsPlantedListItem}
                            </div>

                            <div className={currentTab === 2 ? "row krishak-tab-info brand-loyalty-body" : "row krishak-tab-info brand-loyalty-body d-none"}>
                                <div className="col-lg-2 col-2 mb-3">
                                    {ADD_KRISHAK_SCREEN.BRAND_PURCHASED}
                                </div>
                                <div className="col-lg-10 col-10 mb-3 font-weight-medium">
                                    {ADD_KRISHAK_SCREEN.US_BRANDS}, {ADD_KRISHAK_SCREEN.OTHER_BRANDS}
                                </div>
                                <div className="col-lg-2 col-2">
                                    {ADD_KRISHAK_SCREEN.US_HYBRIDS}
                                </div>
                                <div className="col-lg-10 col-10 mb-3 font-weight-medium">
                                    {usHybridsListItem}
                                </div>
                                <div className="col-lg-2 col-2 mb-3">
                                    {ADD_KRISHAK_SCREEN.OTHER_BRANDS_HYBRIDS}
                                </div>
                                <div className="col-lg-10 col-10 mb-3 font-weight-medium">
                                    {otherHybridsListItem}
                                </div>
                            </div>

                            <div className={currentTab === 3 ? "row krishak-tab-info prerak-body" : "row krishak-tab-info prerak-body d-none"}>
                                <div className="col-lg-2 col-2 mb-3">
                                    {ADD_KRISHAK_SCREEN.SOURCE_INFORMATION_SEEDS}
                                </div>
                                <div className="col-lg-10 col-10 mb-3 font-weight-medium">
                                    {ADD_KRISHAK_SCREEN.FELLOW_FARMER}
                                </div>
                                <div className="col-lg-2 col-2 mb-3">
                                    {ADD_KRISHAK_SCREEN.NEAREST_AGRI_DISTRIBUTOR_RETAILER}
                                </div>
                                <div className="col-lg-10 col-10 mb-3 font-weight-medium">
                                    {nearestDrsListItem}
                                </div>
                                <div className="col-lg-2 col-2 mb-3">
                                    {ADD_KRISHAK_SCREEN.FACTORS_INFLUENCING_PURCHASE_INTENTION}
                                </div>
                                <div className="col-lg-10 col-10 mb-3 font-weight-medium">
                                    {influencingFactorsListItem}
                                </div>
                                <div className="col-lg-2 col-2 mb-3">
                                    {ADD_KRISHAK_SCREEN.POINTS_OF_DECISION_MAKING}
                                </div>
                                <div className="col-lg-10 col-10 mb-3 font-weight-medium">
                                    {krishakInfo.krishak_decision_making_name}
                                </div>
                                <div className="col-lg-2 col-2 mb-3">
                                    {ADD_KRISHAK_SCREEN.FAVOURITE_TV_SHOW}
                                </div>
                                <div className="col-lg-10 col-10 mb-3 font-weight-medium">
                                    {krishakInfo.favourite_tv}
                                </div>
                                <div className="col-lg-2 col-2 mb-3">
                                    {ADD_KRISHAK_SCREEN.FAVOURITE_RADIO_SHOW}
                                </div>
                                <div className="col-lg-10 col-10 mb-3 font-weight-medium">
                                    {krishakInfo.favourite_radio}
                                </div>
                                <div className="col-lg-2 col-2 mb-3">
                                    {ADD_KRISHAK_SCREEN.FAVOURITE_NEWSPAPER}
                                </div>
                                <div className="col-lg-10 col-10 mb-3 font-weight-medium">
                                    {krishakInfo.favourite_news}
                                </div>
                                <div className="col-lg-2 col-2 mb-3">
                                    {ADD_KRISHAK_SCREEN.FELLOW_FARMER_MOBILE_NUMBERS}
                                </div>
                                <div className="col-lg-10 col-10 mb-3 font-weight-medium">
                                    {fellowFarmerMobileNumbersListItem}
                                </div>
                            </div>

                            <div className={currentTab === 4 ? "row krishak-tab-info last-step-body" : "row krishak-tab-info last-step-body d-none"}>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>{ADD_KRISHAK_SCREEN.REMARKS} </label>
                                        <textarea disabled className="form-control font-weight-medium light-gray" rows="6" placeholder={krishakInfo.remark}></textarea></div>
                                </div>

                                <div className="col-md-12">
                                    <span className="font-weight-medium d-flex w-100 align-items-center mt-3 mb-2">{ADD_KRISHAK_SCREEN.IMAGES}</span>
                                    <div className="row row7-5 mb-3">
                                        {krishakImagesListItem}
                                    </div>
                                </div>

                                {/* <div className="row"> */}
                                <hr className="w-100" />
                                {/* </div> */}

                            </div>

                            <div className="row">
                                <div className="col-12 d-flex button-grp-bottom">
                                    <button className="btn btn-secondary w-50 mr-2" onClick={this.handleEditClick}>{COMMON.EDIT}</button>
                                    <button className="btn btn-secondary w-50 mr-2 d-none">{COMMON.SAVE}</button>
                                    <button className="btn btn-primary w-50" onClick={this.handleDeleteClick}>{COMMON.DELETE}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="row">
                        <div className="col-12 d-flex button-grp-bottom"><button className="btn btn-secondary w-50 mr-2 krishak-cancel-btn d-none">Cancel</button><button className="btn btn-secondary w-50 mr-2" id="krishakPrevious">Previous</button><button className="btn btn-primary w-50" id="krishakNext">Next</button><button className="btn btn-primary w-50 d-none" id="krishakSubmit">SUBMIT</button></div>
                    </div> */}

                    <div className="row">
                        <div className="col-12 d-flex">
                            <button className="btn btn-primary w-100 d-md-none" onClick={() => this.goBack()}>{COMMON.BACK}</button>
                        </div>
                    </div>
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                {isLoading ? <Loader /> : null}
                <DesktopFooter />
            </div>

        )
    }
}

export default withRouter(KrishakInfoPage)